<template>
    <b-form class="step-form" @submit.stop.prevent="onSubmit">
        <div v-if="!showPageLoader" class="row">
            <div class="col-lg-12">
                <div class="row">
                    <div
                        v-for="(field, index) in fields"
                        :key="index"
                        :class="{
                            [field.class]: true,
                            'col-lg-12': field.type == 'heading',
                            'col-md-4':
                                field.type !== 'heading' && !field.class,
                            'col-md-8':
                                (index == 4 || index == 6) &&
                                section == 'account-info',
                        }"
                    >
                        <div
                            v-if="field.type == 'heading' && index > 0"
                            class="form-border"
                        ></div>

                        <component
                            :is="field.type"
                            :field="field"
                            :data-segment-id="dataSegmentId"
                        ></component>
                    </div>
                    <div class="col-lg-12"><div class="form-border"></div></div>
                </div>
                <base-button
                    btn-type="submit"
                    btn-variant="primary"
                    btn-label="CONTINUE"
                    class="mr-3"
                    :class="loading ? 'disabled' : ''"
                    :disabled="loading"
                ></base-button>
                <span v-if="loading" class="secondary-color">
                    Please wait. We're processing your request...</span
                >
            </div>
        </div>
        <!-- When data is loading -->
        <base-table-spinner v-if="showPageLoader"></base-table-spinner>
    </b-form>
</template>
<script>
import { mapGetters } from 'vuex'
import { mapState } from 'vuex'

import request from '@/utils/request'

import Heading from '@/components/registration/Heading.vue'
import TextField from '@/components/registration/TextField.vue'
import TextArea from '@/components/registration/TextArea.vue'
import DatePicker from '@/components/registration/DatePicker.vue'
import List from '@/components/registration/List.vue'
import Dropdown from '@/components/registration/Dropdown.vue'
import Radio from '@/components/registration/Radio.vue'
import Checkbox from '@/components/registration/Checkbox.vue'
import PhoneNumber from '@/components/registration/PhoneNumber.vue'
import IdentityType from '@/components/registration/IdentityType.vue'
import IdentityDocumentExpiry from '@/components/registration/IdentityDocumentExpiry.vue'
import Country from '@/components/registration/Country.vue'
import Nationality from '@/components/registration/Nationality.vue'
import TaxId from '@/components/registration/TaxId.vue'
import WorkType from '@/components/registration/WorkType.vue'
import Industry from '@/components/registration/Industry.vue'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        Heading,
        TextField,
        TextArea,
        DatePicker,
        List,
        Dropdown,
        Radio,
        Checkbox,
        PhoneNumber,
        IdentityType,
        IdentityDocumentExpiry,
        Country,
        Nationality,
        TaxId,
        WorkType,
        Industry,
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            section: 'setup-profile',
            fields: [],
            showPageLoader: true,
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapState({
            restrictDuplicateCustomers: (state) =>
                state.registration.restrictDuplicateCustomers,
        }),

        ...mapGetters(['loading', 'dataSegmentId', 'form', 'dataSegmentTypes']),

        // dataSegmentId() {
        //     if (this.$route.params.dataSegmentId) {
        //         return this.$route.params.dataSegmentId
        //     }
        //     return this.$store.getters.dataSegmentId
        // },
    }, // End of Component > mounted

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        dataSegmentId(value) {
            if (value) {
                this.getRecords()
            }
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.getRecords()
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        /**
         * Handle when the form has been submitted
         *
         * @return {void}
         */
        async onSubmit() {
            // validate the form fields
            // const result = await this.$validator.validateAll()
            // console.log("result: ", result)
            // // Check if validation fails
            // if (result) {
            //     this.$store.commit('setLoading', true)

            //       let registrationUrl = '/customers/face-to-face'
            //     if (this.$route.meta.publicRegistration === true) {
            //         registrationUrl = '/customers/non-face-to-face'
            //     }
            //     if (this.restrictDuplicateCustomers) {
            //         //check customer nic if already exists with their datasegment
            //         let error = false
            //         try {
            //             const params = {}
            //             params.dataSegmentId = this.dataSegmentId
            //             params.number =
            //                 this.$store.state.registration.form.identityInfo.number

            //             const { data } = await request({
            //                 url: '/customers/exists',
            //                 method: 'get',
            //                 params,
            //             })
            //         } catch (e) {
            //             error = e
            //         }
            //         if (error) {
            //             this.$store.commit('setError', error)
            //             this.$store.commit('setLoading', false)
            //             return false
            //         }
            //     }

            //     if (this.$route.meta.publicRegistration === true) {
            //         this.$router.push({
            //             name: 'public-registration-finish',
            //             params: {
            //                 dataSegmentId: this.dataSegmentId,
            //             },
            //         })
            //     } else {
            //         console.log("at continue --> go to finish")
            //         this.$router.push('/register-customer/finish')
            //     }
            // } else {
            //     this.$store.commit('setError', this.errors.all()[0])
            // }

            // validate the form fields
            const result = await this.$validator.validateAll()
            console.log('result: ', result)
            // Check if validation fails
            if (result) {
                this.$store.commit('setLoading', true)

                let registrationUrl = '/customers/face-to-face'
                if (this.$route.meta.publicRegistration === true) {
                    registrationUrl = '/customers/non-face-to-face'
                }

                try {
                    const formData = this.$store.state.registration.form
                    formData.dataSegmentId = this.dataSegmentId
                    formData.dataSegmentType = this.dataSegmentTypes

                    console.log('formData', formData)
                    const { data } = await request({
                        url: registrationUrl,
                        method: 'post',
                        data: formData,
                    })
                    console.log('data after non face to face:', data)

                    this.$store.commit('updateField', {
                        key: 'idenfoId',
                        value: data.data.idenfoId,
                    })

                    if (this.$route.meta.publicRegistration === true) {
                        this.$router.push({
                            name: 'public-registration-finish',
                            params: {
                                dataSegmentId: this.dataSegmentId,
                                dataSegmentType: this.dataSegmentTypes,
                            },
                        })
                    } else {
                        console.log('at continue --> go to finish')
                        this.$router.push('/register-customer/finish')
                    }
                } catch (errors) {
                    this.$store.commit('setError', errors.message)
                }
                this.$store.commit('setLoading', false)
            } else {
                this.$store.commit('setError', this.errors.all()[0])
            }
        }, // End of onSubmit() method

        /**
         * get the form fields when required
         *
         * @return {void}
         */
        async getRecords() {
            try {
                let { data } = await request({
                    url: `/form-builder/`,
                    params: {
                        dataSegmentId: this.dataSegmentId,
                        section: this.section,
                        dataSegmentType: this.dataSegmentTypes,
                    },
                })

                this.showPageLoader = false
                this.fields = data.data
            } catch (error) {}
            this.$store.commit('setLoading', false)
        }, // End of getRecords() method
    }, // End of Component > watch
} // End of export default
</script>
